import { trackAnalyticsEvent } from '@/analytics'
import {
  EVENT_ACTION,
  EVENT_CATEGORY,
  ONBOARDING_ACCOUNT_TYPE,
  ONBOARDING_FLOW_TYPE
} from '@/constants/analytics'
import { STORAGE_KEYS } from '@/constants/storage'

/**
 * This contains utilities related to analytics events for Onboarding flows
 */
export default {
  methods: {
    trackOnboardingAnalyticsEvent(action, properties) {
      trackAnalyticsEvent(EVENT_CATEGORY.ONBOARDING, action, {
        onboardingFlowType: sessionStorage.getItem(STORAGE_KEYS.onboardingFlowType),
        accountType: sessionStorage.getItem(STORAGE_KEYS.onboardingAccountType),
        ...properties
      })
      if (action === EVENT_ACTION.ONBOARDING_COMPLETED) {
        this.cleanOnboardingParams()
      }
    },
    isOnboardingViaExternalAuthInProgress() {
      return [ONBOARDING_ACCOUNT_TYPE.GOOGLE, ONBOARDING_ACCOUNT_TYPE.MICROSOFT].includes(
        sessionStorage.getItem(STORAGE_KEYS.onboardingAccountType)
      )
    },
    isSignUpInProgress() {
      return sessionStorage.getItem(STORAGE_KEYS.onboardingFlowType) === ONBOARDING_FLOW_TYPE.SIGNUP
    },
    isSignInInProgress() {
      return (
        sessionStorage.getItem(STORAGE_KEYS.onboardingFlowType) === ONBOARDING_FLOW_TYPE.SIGN_IN
      )
    },
    cleanOnboardingParams() {
      sessionStorage.removeItem(STORAGE_KEYS.onboardingAccountType)
      sessionStorage.removeItem(STORAGE_KEYS.onboardingFlowType)
    },
    setOnboardingFlowType(flowType) {
      sessionStorage.setItem(STORAGE_KEYS.onboardingFlowType, flowType)
    },
    setOnboardingAccountType(accountType) {
      sessionStorage.setItem(STORAGE_KEYS.onboardingAccountType, accountType)
    }
  }
}
